




import { computed, defineComponent } from '@nuxtjs/composition-api';
import ProductLabel from '~/components/partials/Product/ProductLabel.vue';
import { getProductColorFromType } from '~/utils/modules/products';

export default defineComponent({
  components: {
    ProductLabel,
  },
  props: {
    color: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: null,
    },
  },
  setup(props) {
    const labelColor = computed(() => getProductColorFromType(props.color));

    return {
      labelColor,
    };
  },
});
